import { useCommandState } from "cmdk"
import PWAdminCmdKItem from "./PWAdminCmdKItem"
import getPWAdminSSOAuthOptions, {
  getPWAdminSSOAuthOption
} from "./getPWAdminSSOAuthOptions"

function PWAdminCmdKAuth() {
  const search = useCommandState((state) => state.search)
  const pwAdminSSOAuthOptions = getPWAdminSSOAuthOptions()
  // Defaulting to empty string, which will produce the default "admin::" option.
  const pwAdminSSOAuthSearchOption = getPWAdminSSOAuthOption(
    search.split("admin::")[1] || ""
  )

  return (
    <>
      {/* The search item */}
      <PWAdminCmdKItem
        key={pwAdminSSOAuthSearchOption.label}
        option={pwAdminSSOAuthSearchOption}
        // Force the search option to always be mounted, as long as it doesn't
        // duplicate an existing option.
        forceMount={
          !pwAdminSSOAuthOptions.some((option) => option.label === search) &&
          // ...and only if the search matches the start of the label.
          pwAdminSSOAuthSearchOption.label.startsWith(search)
        }
      />
      {/* The stored sso options */}
      {search
        ? pwAdminSSOAuthOptions
            .filter((option) => option.label !== "admin::")
            .map((option) => (
              <PWAdminCmdKItem
                key={option.label}
                option={option}
                hidden={!search}
              />
            ))
        : null}
    </>
  )
}

export default PWAdminCmdKAuth
